import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 mw-600px mx-auto mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-10 text-start" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, " This action will overwrite the existing form, are you sure to proceed? ")
  ])
], -1)


import { defineComponent, defineProps, toRef } from "vue";
import VZModal from "@/components/content/VZModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
const __default__ = defineComponent({
  name: "OverrideTableModal",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showDialog: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  showDialog: boolean;
}

function t(key: string) {
  return TranslationService.translate(key);
}

const showDialog = toRef(props, "showDialog");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(VZModal, {
      title: `Overwrite form`,
      id: "vz_drop_override_table_modal",
      widthClass: 'width-550',
      showDialog: _unref(showDialog),
      onModalClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reject-over-ride')))
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
          tabindex: "1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('reject-over-ride')), ["stop"]))
        }, " Close "),
        _createElementVNode("button", {
          type: "submit",
          tabindex: "0",
          class: "min-w-90px btn btn-outline btn-outline-primary btn-active-light-primary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('confirm-over-ride')), ["stop"]))
        }, " Confirm ")
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}
}

})